import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";
import {
  actionTypes,
  addMobileNumberActionFailure,
  addMobileNumberActionSuccess,
  getConfigFailure,
  getConfigSuccess,
  getSecurityQuestionFailure,
  getSecurityQuestionSuccess,
  saveSecurityQuestionsFailure,
  saveSecurityQuestionsSuccess,
  validateMobileActionFailure,
  validateMobileActionSuccess,
} from "./actions";
import {
  addMobileService,
  fetchQuestionConfig,
  fetchSecurityQuestions,
  postSecurityQuestions,
  validateMobileService,
} from "./services";

const fetchGetQuestionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_SECURITY_QUESTION),
    mergeMap((action: any) =>
      fetchSecurityQuestions().pipe(
        map((response: any) => getSecurityQuestionSuccess(response)),
        catchError((error: any) => of(getSecurityQuestionFailure(error)))
      )
    )
  );

const fetchGetConfigEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_CONFIG),
    mergeMap((action: any) =>
      fetchQuestionConfig().pipe(
        map((response: any) => getConfigSuccess(response)),
        catchError((error: any) => of(getConfigFailure(error)))
      )
    )
  );

const postSecurityQuestionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.POST_SECURITY_QUESTIONS),
    mergeMap((action: any) =>
      postSecurityQuestions(action.payload).pipe(
        map((response: any) => saveSecurityQuestionsSuccess(response)),
        catchError((error: any) => of(saveSecurityQuestionsFailure(error)))
      )
    )
  );

const addMobileNumberEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.ADD_MOBILE_NUMBER),
    mergeMap((action: any) =>
      addMobileService(action.payload).pipe(
        map((response: any) => addMobileNumberActionSuccess(response)),
        catchError((error: any) => of(addMobileNumberActionFailure(error)))
      )
    )
  );

const validateMobileNumberEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.VALIDATE_MOBILE_NUMBER),
    mergeMap((action: any) =>
      validateMobileService(action.payload).pipe(
        map((response: any) => validateMobileActionSuccess(response)),
        catchError((error: any) => of(validateMobileActionFailure(error)))
      )
    )
  );

export default [
  fetchGetQuestionEpic,
  fetchGetConfigEpic,
  postSecurityQuestionEpic,
  addMobileNumberEpic,
  validateMobileNumberEpic,
];
